'use strict';

exports.__esModule = true;
exports.TransactionPage = exports.TransactionsPage = exports.AccountPage = exports.AccountsPage = exports.ContractSourceCreatePage = exports.ContractSourcePage = exports.ContractSourcesPage = exports.SubscriptionProvider = exports.ContextProvider = undefined;

var _class, _temp;

var _templateObject = _taggedTemplateLiteralLoose(['\n  query ethereumNet{\n    ethNet{\n      id\n      isListening\n      peerCount\n    }\n  }\n'], ['\n  query ethereumNet{\n    ethNet{\n      id\n      isListening\n      peerCount\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./styles/less/styles.css');

var _ContractSources = require('./components/pages/ContractSources');

var _ContractSources2 = _interopRequireDefault(_ContractSources);

var _ContractSource = require('./components/pages/ContractSources/ContractSource');

var _ContractSource2 = _interopRequireDefault(_ContractSource);

var _Create = require('./components/pages/ContractSources/ContractSource/Create');

var _Create2 = _interopRequireDefault(_Create);

var _Accounts = require('./components/pages/Accounts');

var _Accounts2 = _interopRequireDefault(_Accounts);

var _Account = require('./components/pages/Accounts/Account');

var _Account2 = _interopRequireDefault(_Account);

var _Transactions = require('./components/pages/Transactions');

var _Transactions2 = _interopRequireDefault(_Transactions);

var _Transaction = require('./components/pages/Transactions/Transaction');

var _Transaction2 = _interopRequireDefault(_Transaction);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _reactApollo = require('react-apollo');

var _materialUi = require('material-ui');

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

var _SubscriptionProvider = require('./components/SubscriptionProvider');

var _SubscriptionProvider2 = _interopRequireDefault(_SubscriptionProvider);

var _ContextProvider = require('./components/ContextProvider');

var _ContextProvider2 = _interopRequireDefault(_ContextProvider);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

exports.ContextProvider = _ContextProvider2.default;
exports.SubscriptionProvider = _SubscriptionProvider2.default;
exports.ContractSourcesPage = _ContractSources2.default;
exports.ContractSourcePage = _ContractSource2.default;
exports.ContractSourceCreatePage = _Create2.default;
exports.AccountsPage = _Accounts2.default;
exports.AccountPage = _Account2.default;
exports.TransactionsPage = _Transactions2.default;
exports.TransactionPage = _Transaction2.default;
var query = (0, _graphqlTag2.default)(_templateObject);
var App = (_temp = _class = function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  App.prototype.render = function render() {
    var _props$data = this.props.data,
        loading = _props$data.loading,
        ethNet = _props$data.ethNet;

    if (!ethNet) {
      if (loading) {
        return null;
      } else {
        return _react2.default.createElement(_materialUi.Typography, {
          color: 'error'
        }, 'Can not get ethereum net info');
      }
    }

    var id = ethNet.id,
        isListening = ethNet.isListening,
        peerCount = ethNet.peerCount;
    return _react2.default.createElement('div', null, _react2.default.createElement(_materialUi.Typography, null, 'Net ID: ', id), _react2.default.createElement(_materialUi.Typography, null, 'isListening: ', (isListening ? true : false).toString()), _react2.default.createElement(_materialUi.Typography, null, 'peerCount: ', peerCount));
  };

  return App;
}(_react.Component), _class.contextType = _context2.default, _temp);
App.propTypes = process.env.NODE_ENV !== "production" ? {
  data: _propTypes2.default.object.isRequired
} : {};
exports.default = (0, _reactApollo.graphql)(query)(App);